import { StateCreator } from 'zustand';

import { Store } from '@/store';

export interface IGoodsDetailState {
  shop_sku: string;
  // 评论弹窗的状态
  reviewDialog: boolean;
}

export interface GoodsDetailActions {
  setShopSku: (shop_sku: IGoodsDetailState['shop_sku']) => void;
  setPartial: (state: Partial<IGoodsDetailState>) => void;
  setReviewDialog: (reviewDialog: IGoodsDetailState['reviewDialog']) => void;
  getReviewDialog: (shop_sku: IGoodsDetailState['shop_sku']) => IGoodsDetailState['reviewDialog'];
}

export type GoodsDetailSlice = IGoodsDetailState & GoodsDetailActions;

export const initialGoodsDetailState: IGoodsDetailState = {
  shop_sku: '',
  reviewDialog: false,
};

export const createGoodsDetailSlice: StateCreator<Store, [], [], GoodsDetailSlice> = (
  set,
  get,
) => ({
  ...initialGoodsDetailState,
  setPartial: (state) => set(state),
  setShopSku: (shop_sku) => set({ shop_sku }),
  setReviewDialog: (reviewDialog) => set({ reviewDialog }),
  getReviewDialog: (shop_sku) => {
    if (shop_sku && shop_sku === get().shop_sku) {
      return get().reviewDialog;
    }
    return false;
  },
});
